import { Route, Routes } from 'react-router-dom';

import { css } from '@emotion/react'
import styled from '@emotion/styled'

// basic routes
import RepairList from '../components/Repairs/RepairList';
import EditRepair from '../components/Repairs/EditRepair';


const Repairs = () => {
  return (
    <Routes>
      <Route path="/" element={<RepairList />} />
      <Route path="/edit/:id" element={<EditRepair />} />
      <Route path="/edit" element={<EditRepair />} />
    </Routes>
  )
}

export default Repairs;